<template>
    <div v-if="isVisible" @click="scrollToTop" class="back-to-top">
      <i class="fas fa-arrow-up"></i> <!-- 使用 FontAwesome 的上箭头图标 -->
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        isVisible: false, // 控制按钮显示/隐藏
      };
    },
    methods: {
      // 滚动到页面顶部
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth', // 平滑滚动效果
        });
      },
      // 监听页面滚动
      handleScroll() {
        this.isVisible = window.scrollY > 300; // 页面滚动超过300px后显示按钮
      },
    },
    mounted() {
      // 监听滚动事件
      window.addEventListener('scroll', this.handleScroll);
    },
    beforeUnmount() {
      // 移除滚动事件监听
      window.removeEventListener('scroll', this.handleScroll);
    },
  };
  </script>
  
  <style scoped>
  .back-to-top {
    position: fixed;
    right: 20px;
    bottom: 20px;
    width: 50px;
    height: 50px;
    background-color: var(--ink, #1b1815);
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: opacity 0.3s ease, box-shadow 0.3s ease;
    box-shadow: 0 2px 8px rgba(27, 24, 21, 0.15);
    opacity: 0.45;
    z-index: 50;
  }

  .back-to-top:hover {
    background-color: var(--ink, #1b1815);
    opacity: 0.85;
    box-shadow: 0 4px 16px rgba(27, 24, 21, 0.2);
  }
  </style>